import commonService from '@/services/common/common.service';
import UrlsConfig from "../../../../config/urls.conf"
import GlobalConstants from '../../../components/common/global.constants'
import Profile from "../../../components/common/profile"

const setLang = (context, payload) => {
  context.commit('SET_LANG', payload);
};

const setApiByEnviroment = (context) => {

  return new Promise((resolve, reject) => {
    commonService.getFrontProfile()
      .then(result => {
        return result.data;
      })
      .then(json => {
        UrlsConfig.profile = json.env;
        let token = json.env === GlobalConstants.LOCAL
            || json.env === GlobalConstants.DEV
            ? GlobalConstants.ACCESS_TOKEN_DEV
                : GlobalConstants.ACCESS_TOKEN
        if(location.hostname.indexOf('cp') > -1){
          token = GlobalConstants.ACCESS_TOKEN_CP;
        }
        context.commit('SET_ACCESS_TOKEN', token);
        context.commit('SET_ENVIRONMENT', json.env);
        Profile.env = json.env;
        resolve();
      })
      .catch((err) => {
        reject(err);
      })
  });
};

const setHomepageInfo = (context, payload) => {

    let host = window.location.host;

    return new Promise((resolve, reject) => {
        commonService.getHomepageInfo(host, payload)
            .then(result => {
                return result.data.result;
            })
            .then(json => {

                if(json.svc) {
                    document.title = json.svc.svcDmnTitl;
                }
                let logo = json.logo;
                //this.$store.commit('setWhiteLabelLogo', logo)

                if(logo.mspCmpnLogoTypeCd == 'MSP_CMPN_LOGO_TYPE_010') {
                    $('#home_login_gnb_logo').html(`<img src="${logo.logoGnbLogin}">`);
                } else {
                    $('#home_login_gnb_logo').html(logo.logoGnbText);
                }

                context.commit('SET_HOMEPAGE_INFO', json);
                resolve();
            })
            .catch((err) => {
                reject(err);
            })
    });
};


export default {
  setLang,
  setApiByEnviroment,
  setHomepageInfo
};



// WEBPACK FOOTER //
// ./src/store/modules/common/actions.js